"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Delay_1 = __importDefault(require("./Delay"));
var Exit_1 = __importDefault(require("./Exit"));
var Immediately_1 = __importDefault(require("./Immediately"));
var Scroll_1 = __importDefault(require("./Scroll"));
var TriggerClass_1 = __importDefault(require("./TriggerClass"));
exports.default = (function (trigger) {
    switch (trigger.condition) {
        case 'delay':
            return new Delay_1.default(trigger.value);
        case 'exit':
            return new Exit_1.default();
        case 'immediately':
            return new Immediately_1.default();
        case 'scroll':
            return new Scroll_1.default(trigger.value);
        default:
            return new TriggerClass_1.default();
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90cmlnZ2Vycy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLGtEQUEyQjtBQUMzQixnREFBeUI7QUFDekIsOERBQXVDO0FBQ3ZDLG9EQUE2QjtBQUM3QixnRUFBeUM7QUFFekMsbUJBQWUsVUFBQyxPQUEwQjtJQUN0QyxRQUFRLE9BQU8sQ0FBQyxTQUFTLEVBQUU7UUFDdkIsS0FBSyxPQUFPO1lBQ1IsT0FBTyxJQUFJLGVBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDbkMsS0FBSyxNQUFNO1lBQ1AsT0FBTyxJQUFJLGNBQUksRUFBRSxDQUFBO1FBQ3JCLEtBQUssYUFBYTtZQUNkLE9BQU8sSUFBSSxxQkFBVyxFQUFFLENBQUE7UUFDNUIsS0FBSyxRQUFRO1lBQ1QsT0FBTyxJQUFJLGdCQUFNLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFBO1FBQ3BDO1lBQ0ksT0FBTyxJQUFJLHNCQUFZLEVBQUUsQ0FBQTtLQUNoQztBQUNMLENBQUMsRUFBQSJ9